export enum Ga4EventName {
    CALCULATOR_START = 'calculator_start',
    CALCULATOR_FIELD_CLICK = 'calculator_field_click',
    CALCULATOR_FIELD_ERROR = 'calculator_field_error',
    CALCULATOR_FIELD_DELETE = 'calculator_field_delete',
    OFFER_ELEMENT_CLICK = 'offer_element_click',
    OFFER_FILTER_CLICK = 'offer_filter_click',
    CHECKOUT_ELEMENT_CLICK = 'checkout_element_click',
    CALCULATOR_VIEW = 'calculator_view',
    CLICK_PAYMENT_ONLINE = 'click_payment_online',
    CLICK_PAYMENT_OFFLINE = 'click_payment_offline',
    CLICK_PAYMENT_CARD = 'click_payment_card',
    CLICK_PAYMENT_PARTNER = 'click_payment_partner',
    RECALCULATION_VIEW = 'recalculation_view',
}
